var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edit-alt_svg__clip0)",
    fill: "#797584"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.707 8.707l6-6a1 1 0 000-1.414l-1-1a1 1 0 00-1.414 0l-6 6a1 1 0 00-.188.26l-.812 3.154L4.447 8.9a1 1 0 00.26-.193zM11.5 11H.5a.5.5 0 000 1h11a.5.5 0 000-1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edit-alt_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}

export default SvgEditAlt;